export type CustomProjectNameValues = {
  name: string;
};

type CustomProjectNameValidate = {
  name?: string;
};

export const CustomProjectNameValidator = (
  values: CustomProjectNameValues
): CustomProjectNameValidate => {
  const err: CustomProjectNameValidate = {};

  if (!values.name?.trim()) {
    err.name = 'app.validation.not-project-name';
  }

  return err;
};
